import WhiteLabelSettingsService from "../services/whiteLabelSettings";

export const REQUEST_FAILED = "REQUEST_FAILED";
export const REQUEST_WHITE_LABEL_SETTINGS = "REQUEST_WHITE_LABEL_SETTINGS";
export const SET_WHITE_LABEL_SETTINGS = "SET_WHITE_LABEL_SETTINGS";

const requestFailed = (error) => ({
  type: REQUEST_FAILED,
  error,
});

const requestGetWhiteLabelSettingForApp = (appId) => ({
  type: REQUEST_WHITE_LABEL_SETTINGS,
  appId,
});

const setWhiteLabelSettings = (settings) => ({
  type: SET_WHITE_LABEL_SETTINGS,
  settings,
});

export const getWhiteLabelSettingsForApp = (appId) => async (dispatch) => {
  dispatch(requestGetWhiteLabelSettingForApp(appId));

  const tmpSetting = {
    1: {
      isWhiteLabel: true,
      primaryColor: "#032C3D",
      accentColor: "#9AABB1",
      logoUrl:
        "https://system-data.s3.us-west-2.amazonaws.com/resources/white_label_app_logo/GoodLifePT_Transparent_AndroidAppIcon.png",
      appName: "Good Life PT",
      appCode: "GL",
    },
    2: {
      isWhiteLabel: true,
      primaryColor: "#0b73ad",
      accentColor: "#e5c645",
      logoUrl:
        "https://system-data.s3.us-west-2.amazonaws.com/resources/white_label_app_logo/RestoreAndroidStoreIcon_Transparent.png",
      appName: "Restore Your Core PT",
      appCode: "RC",
    },
    3: {
      isWhiteLabel: true,
      primaryColor: "#d4bc90",
      accentColor: "#912F1E",
      logoUrl:
        "https://app-image-storage.s3.us-west-2.amazonaws.com/images/5823/ae4d2655-ad22-447f-bede-3d812b5d89c7.jpg",
      appName: "Madrona Physical Therapy",
      appCode: "MD",
    },
    4: {
      isWhiteLabel: true,
      primaryColor: "#315579",
      accentColor: "#ff6c2c",
      logoUrl:
        "https://app-image-storage.s3.amazonaws.com/images/9126/313f74d8-2a05-44a6-99d4-999c81cea832.jpg",
      appName: "PT Tech",
      appCode: "PT",
    },
    5: {
      //Big Heart
      isWhiteLabel: true,
      primaryColor: "#008eaa",
      accentColor: "#ff671f",
      logoUrl:
        "https://user-image-storage.s3.amazonaws.com/images/10278/4a7b9555-2b3b-41ca-934d-208d45d19073.jpg",
      appName: "Big Heart Center For Brain Change",
      appCode: "BH",
    },
    6: {
      //Brownstone
      isWhiteLabel: true,
      primaryColor: "#ADADAD",
      accentColor: "#0D3A80",
      logoUrl:
        "https://user-image-storage.s3.amazonaws.com/images/12833/c70bfca7-57b5-41a1-bfec-8b16d8c806c3.jpg",
      appName: "",
      appCode: "BR",
    },
    7: {
      //Altitude
      isWhiteLabel: true,
      primaryColor: "#008eaa",
      accentColor: "#002878",
      logoUrl:
        "https://user-image-storage.s3.amazonaws.com/images/12835/e72809b2-d835-446f-95a9-886a5e81156d.jpg",
      appName: "",
      appCode: "AT",
    },
    8: {
      //Koi
      isWhiteLabel: true,
      primaryColor: "#C4C5AE",
      accentColor: "#4A5739",
      logoUrl:
        "https://user-image-storage.s3.amazonaws.com/images/9468/f8fb5d35-a231-4f1e-b9bd-e6a4277a8264.jpg",
      appName: "",
      appCode: "KW",
    },
    9: {
      //Trabecule X
      isWhiteLabel: true,
      primaryColor: "#1aa260",
      accentColor: "#50C878",
      logoUrl:
        "https://user-image-storage.s3.amazonaws.com/images/2080/3fd29cd9-ebb6-4a7f-a803-5ec9d100b469.jpg",
      appName: "",
      appCode: "TR",
    },
    10: {
      //Shelby Symmetry
      isWhiteLabel: true,
      primaryColor: "#1aa260",
      accentColor: "#000000",
      logoUrl:
        "https://user-image-storage.s3.us-west-2.amazonaws.com/images/18191/987c0bc6-9e7f-4559-99e5-e656a795ddfb.jpg",
      appName: "Shelby Symmetry",
      appCode: "SS",
    },
    11: {
      //ROOTS
      isWhiteLabel: true,
      primaryColor: "#000000",
      accentColor: "#50C878",
      logoUrl:
        "https://system-data.s3.us-west-2.amazonaws.com/resources/white_label_app_logo/ROOTS_white_logo.png",
      appName: "ROOTS",
      appCode: "RT",
    },
    12: {
      // Movement Medicine PT
      isWhiteLabel: true,
      primaryColor: "#143875",
      accentColor: "#3EC775",
      logoUrl: 'https://system-data.s3.us-west-2.amazonaws.com/resources/white_label_app_logo/movement-medicine-logo-full-color-rgb.jpg',
      appName: "Movement Medicine PT",
      appCode: "MM",
    },
    13: {
      // Galaxy HEP
      isWhiteLabel: true,
      primaryColor: "#878787",
      accentColor: "#F57E20",
      logoUrl: 'https://user-image-storage.s3.amazonaws.com/images/21387/9b855519-46c5-4d1c-b5e7-38bd086f8605.jpg',
      appName: "Galaxy HEP",
      appCode: "GH",
    },
  };

  dispatch(setWhiteLabelSettings(tmpSetting[appId]));
};



// WEBPACK FOOTER //
// ./src/actions/whiteLabelSettings.js